<template>
  <v-container fluid class="pt-0">
    <v-row justify="center">
      <v-col cols="12">
        <v-card tile elevation="1" class="fill-height pa-1 pt-2" min-height="280" >
          <v-card-title class="pa-0">
            <v-toolbar elevation="0" class="pa-0">
              <v-toolbar-title>
                Список категорій пільг
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <MainModal
                  :main="{ component: 'PrivilegeCategory', title: 'Категорії пільг' }"
                  :button="{ icon: true, color: 'grey lighten-4', buttonIcon: 'mdi-plus' }"
                  @updateItemModal="updateItemModal"
              />
            </v-toolbar>
          </v-card-title>
          <v-data-table
              v-model="selected"
              :headers="tableHeader"
              :items="items"
              :single-select="true"
              :show-select="selectable"
              no-data-text="Дані відсутні. Жодного запису не виявлено"
              :footer-props="{
                  showFirstLastPage: true,
                  itemsPerPageText: 'Рядків на сторінку',
                  itemsPerPageOptions: [15, 30, -1],

                }"
              class="custom-table custom-table-1"
              @click:row="openComponentModal"
              @item-selected="selectRow"
          >
            <template v-slot:item.icon="{ item }">
              <MainModal
                  :main="{ component: 'PrivilegeCategory', title: 'Категорії пільг' }"
                  :button="{ iconActivator: true, class: 'mr-2', color: 'success', buttonIcon: 'mdi-format-list-numbered', iconSize: 26 }"
                  :item="{
                      id: item.id,
                      name: item.name,
                      percent: item.percent,
                      budget: item.budget,
                      edarp_code: item.edarp_code
                    }"
                  :modal="dialog_id === item.id"
                  @updateItemModal="updateItemModal"
              />
            </template>

            <template v-slot:item.create_date="{ item }">
              <span>
                {{ item.create_date | formatDate }}
              </span>
            </template>
            <template v-slot:item.budget="{ item }">
              <span>
                {{ getBudgetName(item.budget) }}
              </span>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {FETCH_PRIVILEGE_CATEGORIES} from "@/store/actions/privilege";
import {getBudgetType} from "@/utils/icons"

export default {
  props: ['selectable', 'model'],
  name: "CategoryView",
  components: {
    MainModal: () => import("@/components/modal/MainModal")
  },
  computed: {
    ...mapGetters({
      items: 'getPrivilegeCategories'
    })
  },
  data() {
    return {
      selected: [],
      tableHeader: [
        { text: '', value: 'icon', width: 26 },
        { text: 'Найменування', value: 'name' },
        { text: '%', value: 'percent' },
        { text: 'Бюджет', value: 'budget' },
        { text: 'Код (ЄДАРП)', value: 'edarp_code' },
        { text: 'Створено', value: 'create_date' },
        { text: 'Автор', value: 'owner_name' },
      ],
      dialog_id: 0
    }
  },
  methods: {
    ...mapActions({
      fetch: FETCH_PRIVILEGE_CATEGORIES
    }),
    getBudgetName(name) {
      return getBudgetType(name)
    },
    selectRow(payload) {
      this.$emit('selectedItemRow', payload.value ? payload.item : undefined)
    },
    openComponentModal(payload) {
      this.dialog_id = payload.id
    },
    updateItemModal() {
      this.dialog_id = 0
    }
  },
  watch: {
    model(payload) {
      if (payload) {
        this.selected = []
        this.fetch()
      }
    }
  },
  created() {
    this.fetch()
  }
}
</script>

<style scoped>

</style>